import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  AlertController,
  LoadingController,
  ModalController,
} from "@ionic/angular";
import { STORAGE } from "src/app/constant/storages";
import { ApiserviceService } from "src/app/httpservice/apiservice.service";
import { _getStorage } from "src/app/utils/local-storage";
import { TEXT } from "../../../text_control/index";

@Component({
  selector: "app-resend-taxinvoice",
  templateUrl: "./resend-taxinvoice.component.html",
  styleUrls: ["./resend-taxinvoice.component.scss"],
})
export class ResendTaxinvoiceComponent implements OnInit {
  @Input() sendEmail: any;
  @Input() data: any;

  email = "";
  label_text: any = {};

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  constructor(
    public alertController: AlertController,
    public modalCtrl: ModalController,
    public router: Router,
    public apiservice: ApiserviceService,
    public loadingController: LoadingController
  ) {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);
    this.label_text = TEXT;
  }

  ngOnInit() {}

  isDisableClick: boolean = false;
  loading: any;
  async confirmWaitAlert() {
    if (this.sendEmail === "") {
      const alert = await this.alertController.create({
        cssClass: "resend-confirm-email",
        header: "กรุณาระบุ Email Address",
        buttons: [
          {
            text: "OK",
            role: "OK",
            cssClass: "alertButton",
          },
        ],
      });
      await alert.present();
      return;
    } else {
      if (this.sendEmail != "") {
        const re =
          /^(([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(this.sendEmail)) return this.validateEmail();
      }
    }
    this.isDisableClick = true;
    setTimeout(async () => {
      await this.confirmAlert();
    }, 2000);
  }

  async validateEmail() {
    const alert = await this.alertController.create({
      cssClass: "resend-confirm-email",
      header: "รูปแบบ email ไม่ถูกต้อง",
      buttons: [
        {
          text: "OK",
          role: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }

  async confirmAlert() {
    let invoiceList = [];
    for (let d of this.data) {
      invoiceList.push({
        taxno:
          d.type_invoice == "creditnote" ? d.creditnote_no : d.tax_invoice_no,
        storebu: d.bu,
        storeid: d.loc,
        mtrans_id: d.mtrans_id,
      });
    }

    let data = {
      invoice_tosend: invoiceList,
      buyeremail: this.sendEmail,
      userBu: this.userBu,
      userLoc: this.userLoc,
      userRole: this.userRole,
      userSource: this.userSource,
      user_id: this.userID,
    };

    console.log("====== req send email ========", data);

    try {
      await this.apiservice
        ._post(
          this.apiservice.apiUrl + this.apiservice.getNewResendInvoice,
          data
        )
        .then(async (res: any) => {
          if (res.statusCode === 200) {
            const alert = await this.alertController.create({
              cssClass: "my-confirm-alert",
              header:
                "ระบบได้ดำเนินการส่งรายละเอียด เพื่อสร้างเอกสารอิเล็กทรอนิกส์เรียบร้อยแล้ว โดยนำส่งตาม E-mail ที่มีการระบุไว้",
            });
            setTimeout(async () => {
              await alert.dismiss();
              this.modalCtrl.dismiss({ dismissed: true });
              this.isDisableClick = false;
            }, 4000);
            await alert.present();
          } else {
            const alert = await this.alertController.create({
              cssClass: "my-confirm-alert",
              header: res.statusMessage,
              buttons: [
                {
                  text: "OK",
                  role: "OK",
                  cssClass: "alertButton",
                  handler: (blah) => {
                    this.modalCtrl.dismiss({
                      dismissed: true,
                    });
                  },
                },
              ],
            });
            await alert.present();
          }
        });
    } catch (error) {
      this.modalCtrl.dismiss({
        dismissed: true,
      });
    }
  }
  checkemail(e) {
    this.sendEmail = e.target.value.match(/[0-9a-z._@A-Z- ]*/)[0];
  }

  dismiss() {
    this.modalCtrl
      .dismiss({
        dismissed: true,
      })
      .then((res: any) => {
        if (res) {
        }
      });
  }
  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }
}
